import { render, staticRenderFns } from "./cPartTypeIcon.vue?vue&type=template&id=3da2e386"
import script from "./cPartTypeIcon.vue?vue&type=script&lang=js"
export * from "./cPartTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports